import React, { useState } from 'react';
import { Text, Button, Input, VStack, useToast, HStack } from '@chakra-ui/react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { careerApi, applicantToken } from './careerApi';
import { AuthShell } from './Signup';

export default function Login() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await careerApi.login({ email, password });
      applicantToken.set(res.token);
      nav(params.get('redirect') || '/my-applications');
    } catch (err) {
      toast({ title: 'Login failed', description: err.message, status: 'error' });
    }
    setBusy(false);
  }

  return (
    <AuthShell title="Welcome back">
      <form onSubmit={submit}>
        <VStack spacing="12px" align="stretch">
          <Input placeholder="Email" size="md" type="email" required value={email} onChange={e => setEmail(e.target.value)} />
          <Input placeholder="Password" size="md" type="password" required value={password} onChange={e => setPassword(e.target.value)} />
          <Button type="submit" bg="#3730A3" color="white" _hover={{ bg: '#312E81' }} isLoading={busy}>Log in</Button>
        </VStack>
      </form>
      <HStack justifyContent="space-between" mt="16px" fontSize="13px">
        <Text as={Link} to="/forgot-password" color="#3730A3">Forgot password?</Text>
        <Text as={Link} to="/signup" color="#3730A3" fontWeight="700">Create account</Text>
      </HStack>
    </AuthShell>
  );
}
